module.exports = __webpack_public_path__ + "img/Icon_listing2.6f770e47.svg";